import Main from './src/Main';

export default Main;
